'use client';

import { Grid2 } from '@mui/material';

export const CampaignImage = ({ image }: { image: string }) => {
	if (!image) return null;

	return (
		<Grid2 container direction="row" justifyContent="center" style={{ marginTop: '30px' }}>
			<Grid2 size={{ xs: 12 }}>
				{/* eslint-disable-next-line @next/next/no-img-element */}
				<img alt="campaignImage" src={image} style={{ width: '100%' }} />
			</Grid2>
		</Grid2>
	);
};
